import register  from '../register.js';
import dom       from '../lib/util/dom.js';
import phoneMask from '../lib/util/phone-mask';

register( 'sms-qr-link-form', function() {
  const form        = document.querySelector('#qr-form');
  const qr          = document.querySelector('#qr');
  const phone       = form.querySelector('input[name="phone"]');
  const submitBtn   = form.querySelector('button[type="submit"]');
  const formError   = form.querySelector('.form-error');
  const formSuccess = form.querySelector('.form-success');
  const phoneRegex  = /^\d{3}-\d{3}-\d{4}$/;

  const validations = {
    phone: {
      rule( val ) {
        return val === '' || phoneRegex.test( val );
      },
      errorMsg: 'Please enter a valid phone number'
    }
  };

  const fieldsToSubmit = [ phone ];

  [ phone ].forEach( ( input ) => {
    input.addEventListener( 'keyup', ( evt ) => {
      checkRequiredFields( evt );
      setInputError( evt.target, '' );
      setFormError('');
      setFormSuccess('');
    });
  });

  form.addEventListener( 'submit', submitForm, false );
  phoneMask( phone );

  // When the QR code is clicked, navigate directly to the url it represents
  qr.addEventListener( 'click', () => {
    const url = qr.getAttribute('url');
    document.location = url;
  });

  function checkRequiredFields() {
    const phoneVal = phone.value;
    const shouldDisableBtn = phoneVal.length < 12;

    submitBtn.disabled = shouldDisableBtn;
  }

  function setFormError( txt = '' ) {
    formError.textContent = txt;
  }

  function setFormSuccess( txt = '' ) {
    formSuccess.textContent = txt;
  }

  function setInputError( input, txt = '' ) {
    input.parentElement.querySelector('.error').textContent = txt;
  }

  function validateInput( input ) {
    const { name, value } = input;
    const validationObj   = validations[ name ];

    if ( typeof validationObj === 'undefined' ) {
      return true;
    }

    const { rule, errorMsg } = validationObj;

    const isValid = rule( value );
    const msg     = isValid ? '' : errorMsg;

    setInputError( input, msg );

    return isValid;
  }

  function submitForm( evt ) {
    evt.preventDefault();

    const validations = fieldsToSubmit.map( validateInput );
    const formValid   = validations.every( v => v === true );

    if ( !formValid ) {
      return;
    }

    const formData = fieldsToSubmit.reduce( ( all, next ) => {
      all[ next.name ] = next.value;
      return all;
    }, {} );

    const opts = {
      url: window.location.pathname + '/sms',
      method: 'POST'
    };

    setFormError('');
    setFormSuccess('');
    submitBtn.classList.add('loading');

    dom.ajax( opts, formData, ( err, res ) => {
      submitBtn.classList.remove('loading');
      if ( err ) {
        setFormError('An error occurred, please try again');
        return false;
      }
      return handleSuccess( res );
    });
  }

  function handleSuccess() {
    setFormSuccess( '✅ Link sent to ' + phone.value );
    setFormError();
    phone.value = '';
  }

});

export default undefined;
